import { startCase } from 'lodash';

export const formatUserName = (
  username: string | null | undefined
): string | undefined =>
  username ? startCase(username.toLowerCase()) : undefined;

export const getDisplayedName = ({
  firstName,
  lastName,
}: {
  firstName?: string | null;
  lastName?: string | null;
}) => {
  const trimmedFirstName = firstName?.trim() || '';
  const trimmedLastName = lastName?.trim() || '';
  return `${trimmedFirstName} ${trimmedLastName}`.trim();
};
